import React from 'react';
import { useIsMobile } from '../../hooks/useMediaQuery';
import type { Builder, BuilderDerived, Dispatch } from '../../hooks/useDietPlanBuilder';
import type { TargetEdit } from '../../state/builderReducer';
import type { Patient, Plan } from '../../types';
import { MealsStepDesktop } from './MealsStepDesktop';
import { MealsStepMobile } from './MealsStepMobile';

export function MealsStep({
  plan,
  patient,
  derived,
  mi,
  oi,
  targetEdit,
  dispatch,
  api,
  kaira,
}: {
  plan: Plan;
  patient: Patient;
  derived: NonNullable<BuilderDerived>;
  mi: number;
  oi: number;
  targetEdit: TargetEdit | null;
  dispatch: Dispatch;
  api: Builder['api'];
  kaira: Builder['kaira'];
}) {
  const isMobile = useIsMobile();
  if (isMobile) return <MealsStepMobile plan={plan} derived={derived} dispatch={dispatch} />;
  return (
    <MealsStepDesktop
      plan={plan}
      patient={patient}
      derived={derived}
      mi={mi}
      oi={oi}
      targetEdit={targetEdit}
      dispatch={dispatch}
      api={api}
      kaira={kaira}
    />
  );
}
